import { render } from "./QuoteSection.vue?vue&type=template&id=702d8a35&scoped=true"
import script from "./QuoteSection.vue?vue&type=script&lang=js"
export * from "./QuoteSection.vue?vue&type=script&lang=js"

import "./QuoteSection.vue?vue&type=style&index=0&id=702d8a35&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702d8a35"]])

export default __exports__